import ModalHeader from 'LuxKit/Modal/ModalHeader'
import { useAppSelector } from 'hooks/reduxHooks'
import { useIntl } from 'react-intl'

function AccountMenuDrawerHeader() {
  const intl = useIntl()
  const accountGivenName = useAppSelector(state => state.auth.account.givenName)

  const title = accountGivenName
    ? intl.formatMessage(
        {
          id: 'kwk86s2oZ-cmvzBScL93',
          defaultMessage: 'Hi, {name}',
          description: 'Account menu drawer header greeting with user name',
        },
        { name: accountGivenName },
      )
    : intl.formatMessage({
        id: '6iRMdM7QXxUUu4uOeSDD',
        defaultMessage: 'Hello',
        description: 'Account menu drawer header greeting on the user account settings page',
      })

  return <ModalHeader title={title} />
}

export default AccountMenuDrawerHeader
